/*
   * 当type=1时获取出生日期,type=2时获取性别,type=3时获取年龄
   * */
export function idcardInfo(IdCard, type) {
  if (type === 1) {
    //获取出生日期
    let birthday = IdCard.substring(6, 10) + "-" + IdCard.substring(10, 12) + "-" + IdCard.substring(12, 14)
    return birthday
  }
  if (type === 2) {
    //获取性别
    if (parseInt(IdCard.substr(16, 1)) % 2 === 1) {
      return "1"
    } else {
      return "0"
    }
  }
  if (type === 3) {
    //获取年龄
    var ageDate = new Date()    
    var month = parseInt(ageDate.getMonth()) + 1
    var day = parseInt(ageDate.getDate())
    var age = parseInt(ageDate.getFullYear()) - parseInt(IdCard.substring(6, 10)) - 1
    if (parseInt(IdCard.substring(10, 12)) < month || parseInt(IdCard.substring(10, 12)) === month && parseInt(IdCard.substring(12, 14)) <= day) {
      age++
    }
    // 特殊需求 要算虚岁
    // var age = ageDate.getFullYear() - IdCard.substring(6, 10)

    if (age <= 0) {
      age = 1
    }
    return age
  }
}